import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  Fade,
  styled,
  keyframes,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Avatar,
} from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import { useFetchWorkAnniversaryQuery } from '../../Home/homeApiSlice';
import { empty } from '../../Gift/assets/index';
import lottie from 'lottie-web';
import workAnniversaryImage from './workanniversary.jpg';
import workAnniversary2Image from './workanniversary2.jpg';

const WorkAnniversary = () => {
  const {
    data: workAnniversary = [],
    isLoading,
    isError,
  } = useFetchWorkAnniversaryQuery(undefined, {
    refetchOnMountOrArgChange: true, // forces re-call on mount
  });

  console.log('Work Aniversary: ', workAnniversary);

  const animationContainer = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day); // Note: month is zero-based
  };

  const calculateExperience = (startDate) => {
    const start = parseDate(startDate);

    // Check if the date is valid
    if (isNaN(start.getTime())) {
      throw new Error('Invalid startDate format');
    }

    const now = new Date();
    let experience = now.getFullYear() - start.getFullYear();

    if (now.getMonth() < start.getMonth()) {
      // if (now.getMonth() < start.getMonth() || (now.getMonth() === start.getMonth() && now.getDate() < start.getDate())) {
      experience--;
    }

    return experience;
  };

  const anniversaryAnimation = {
    animation: 'fadeIn 2s ease-in-out',
  };

  const noAnniversaryAnimation = {
    opacity: 0,
  };

  useEffect(() => {
    if (animationContainer.current) {
      const animationData =
        workAnniversary && workAnniversary.length > 0 ? anniversaryAnimation : noAnniversaryAnimation;
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
      animationContainer.current.style.width = '250px';
      animationContainer.current.style.height = '250px';
    }
    return () => {
      if (animationContainer.current) {
        animationContainer.current.innerHTML = '';
      }
    };
  }, [workAnniversary]);

  const handleNavigation = (direction) => {
    if (direction === 'next') {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % filteredAnniversaries.length);
    } else if (direction === 'prev') {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + filteredAnniversaries.length) % filteredAnniversaries.length);
    }
  };

  const handleTap = (e) => {
    const screenWidth = e.currentTarget.clientWidth;
    const tapPosition = e.clientX - e.currentTarget.getBoundingClientRect().left;
    const tapDirection = tapPosition < screenWidth / 2 ? 'prev' : 'next';
    handleNavigation(tapDirection);
  };

  const rotate = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

  const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'black',
    color: 'white',
    paddingTop: '20vh',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    position: 'relative',
    borderRadius: 0,
    border: 1,
    borderColor: 'white',
    overflow: 'hidden',
  }));

  const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    '&:nth-of-type(odd)::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      // backgroundImage: `url(${workAnniversaryImage})`,
       background: 'linear-gradient(45deg,#102C57,#1679AB)' ,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'blur(2px)', // Apply blur to the background image only
      zIndex: -1, // Ensure the pseudo-element is behind the content
    },
    '&:nth-of-type(even)::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
     background: 'linear-gradient(45deg,#102C57,#1679AB)' ,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'blur(2px)', // Apply blur to the background image only
      zIndex: -1, // Ensure the pseudo-element is behind the content
    },
  }));

  const StyledTypography = styled(Typography)(({ theme }) => ({
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '10px',
    color: 'white',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
  }));

  const CounterTypography = styled(Typography)(({ theme }) => ({
    position: 'absolute',
    zIndex: 10,
    color: 'white',
    bottom: 90,
    right: '0',
    left: '40%',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '5px 10px',
    borderRadius: '5px',
  }));

  if (isLoading) {
    return (
      <Box
        sx={{
          backgroundColor: 'black',
          border: 'none',
          borderRadius: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: '100000',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '60vh',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography sx={{ mt: 2, color: 'white' }}>Loading...</Typography>
        </Box>
      </Box>
    );
  }

  
  const today = new Date();
  const todayDay = today.getDate();
  const todayMonth = today.getMonth() + 1;
  const upcomingAnniversaries = workAnniversary.filter(emp => {
    const [day, month] = emp.EventDate.split('/').map(Number);

  if (month === todayMonth && day >= todayDay) return true;
  if (todayDay >= 24 && (month === todayMonth + 1 || (todayMonth === 12 && month === 1)) && day <= 7) return true;
  
  return false;
});

const dateArray = upcomingAnniversaries.map(emp => parseDate(emp.EventDate).getDate());

const hasEndOfMonth = dateArray.some(day => day >= 24);
const hasStartOfMonth = dateArray.some(day => day <= 7);

let sortedAnniversaries;

if (hasEndOfMonth && hasStartOfMonth) {
  const endOfMonth = upcomingAnniversaries
  .filter(emp => parseDate(emp.EventDate).getDate() >= 24)
  .sort((a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate());
  
  const startOfMonth = upcomingAnniversaries
  .filter(emp => parseDate(emp.EventDate).getDate() <= 7)
  .sort((a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate());

  sortedAnniversaries = [...endOfMonth, ...startOfMonth];
} else {
  sortedAnniversaries = upcomingAnniversaries.sort(
    (a, b) => parseDate(a.EventDate).getDate() - parseDate(b.EventDate).getDate()
  );
}

// Filter out anniversaries that are not valid for today
const filteredAnniversaries = sortedAnniversaries.filter((employee) => {
  // const today = new Date();
  // const employeeDate = parseDate(employee.doj);
  const experience = calculateExperience(employee.EventDate);
  return experience >= 1 
});

console.log('filteredAnniversaries', filteredAnniversaries)
const formatDate = (dateStr) => {
  const date = parseDate(dateStr);
  const options = { day: 'numeric', month: 'long' };
  return date.toLocaleDateString(undefined, options);
  };

  const isToday = (dateStr) => {
    const date = parseDate(dateStr);
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth();
  };

  if (isError || filteredAnniversaries?.length === 0) {
    return (
      <Box
        sx={{
          backgroundColor: 'black',
          border: 'none',
          borderRadius: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: '100000',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            marginTop: '10rem',
          }}
        >
          <img style={{ width: '50%' }} src={empty} alt="pending" />
          <Typography sx={{ fontSize: '1rem', p: 2, color: 'lightgrey' }}>No Work Anniversaries This Week</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <StyledCard onClick={handleTap}>
      {/* Counter Display */}
      <Fade in={true} timeout={500} mountOnEnter unmountOnExit>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '45%',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              overflowX: 'scroll',
              scrollBehavior: 'smooth',
              width: '100%',
              height: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              scrollSnapType: 'x mandatory',
              scrollSnapAlign: 'start',
              '& > div': {
                scrollSnapAlign: 'center',
              },
            }}
          >
            {filteredAnniversaries.map((employee, index) => (
              <StyledBox
                key={employee._id || index}
                sx={{
                  flex: '0 0 auto',
                  width: isSmallScreen ? '100%' : '100%',
                  height: '100%',
                  transform: `translateX(-${currentIndex * 100}%)`,
                  transition: 'transform 0.5s ease',
                }}
              >
                {console.log('Employeee:-', employee)}

                <Avatar
                  src={employee?.UserImage} // replace with your image source
                  sx={{
                    width: '100px',
                    height: '100px',
                    border: '4px solid #fff',
                    img: { objectFit: 'cover', objectPosition: 'top' },
                  }}
                />

                <StyledTypography>
                  {employee.FirstName} {employee.LastName}
                </StyledTypography>
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: 'white',
                    mt: 1,
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                  }}
                >
                  {/* {calculateExperience(employee.EventDate) < 1 ? (
                    <>Completed 1 year</>
                  ) : (
                    <>
                      Completed {calculateExperience(employee.EventDate)}{' '}
                      {calculateExperience(employee.EventDate) === 1 ? 'year' : 'years'}
                    </>
                  )} */}
                  Completed {employee.Experience}{' '}
                      {employee.Experience == 1 ? 'year' : 'years'}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ color: 'white', marginTop: '5px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
                >
                  {isToday(employee.EventDate) ? 'Today' : formatDate(employee.EventDate)} 🎉
                </Typography>
              </StyledBox>
            ))}
          </Box>
        </Box>
      </Fade>
      <CounterTypography>
        {currentIndex + 1}/{filteredAnniversaries.length}
      </CounterTypography>
    </StyledCard>
  );
};

export default WorkAnniversary;
